import {
  REMOVE_PRACTICE_SUCCESS,
  REMOVE_PRACTICE_FAIL,
  REMOVE_PRACTICE_RESET,
  REMOVE_PRACTICE_SUBMIT,
} from '../../actions/RemovePractice/removePracticeActions'

interface RemovePracticeState {
  submit: {
    inProgress: boolean
    success: boolean
    fail: boolean
    error?: string | null
  }
}

const initialState: RemovePracticeState = {
  submit: {
    inProgress: false,
    success: false,
    fail: false,
    error: null,
  },
}

type RemovePracticeActions =
  | { type: typeof REMOVE_PRACTICE_SUCCESS }
  | { type: typeof REMOVE_PRACTICE_RESET }
  | { type: typeof REMOVE_PRACTICE_FAIL; error: string }
  | { type: typeof REMOVE_PRACTICE_SUBMIT; payload: { providerNumber: string; practiceName: string } }

const removePracticeReducer = (state = initialState, action: RemovePracticeActions): RemovePracticeState => {
  switch (action.type) {
    case REMOVE_PRACTICE_SUBMIT:
      return {
        ...state,
        submit: { inProgress: true, success: false, fail: false, error: null },
      }
    case REMOVE_PRACTICE_SUCCESS:
      return {
        ...state,
        submit: { inProgress: false, success: true, fail: false, error: null },
      }
    case REMOVE_PRACTICE_FAIL:
      return {
        ...state,
        submit: { inProgress: false, success: false, fail: true, error: action.error },
      }
    case REMOVE_PRACTICE_RESET:
      return initialState
    default:
      return state
  }
}

export default removePracticeReducer
